import { BaseModel } from "./base.model";

export class GenericIntegrationModel extends BaseModel {

    type_id: number;
    customer_id: number;
    customer_name: string;

    external_api: string;
    external_token: string;

    constructor(gi?: GenericIntegrationModel) {
        super();

        this.type_id = gi ? gi.type_id || null : null;
        this.customer_id = gi ? gi.customer_id || null : null;
        this.customer_name = gi ? gi.customer_name || null : null;

        this.external_api = gi ? gi.external_api || null : null;
        this.external_token = gi ? gi.external_token || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/generic-integration.model.ts